// import React from 'react'

// const WarrantyClaimsDetails = () => {
//   return (
//     <div>WarrantyClaimsDetails</div>
//   )
// }

// export default WarrantyClaimsDetails



import React, { useEffect, useState } from 'react';
import backicon from "../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API';
// import PhysicalStockin from '../PhysicalStock-in';
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import Loader from '../../../../customComponents/CustomLoader';

const WarrantyClaimsDetails = () => {

  const [ physicalStockTakingList, setPhysicalStockTakingList ] = useState([])
  const [ formData, setFormData ] = useState([])
  const [ stockTypesData, setStockTypesData ] = useState([])
  const navigate = useNavigate()
  const [ businessPartnerIdState, setBusinessPartnerIdState ] = useState(null)
  const token = localStorage.getItem("authToken");
  const [vendorId,setVendorId] = useState()
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const { data } = location.state || {};
  const PhysicalStockinId = data?.phystkin_id
  console.log("locationdata<><><>",data);
  
 useEffect(() => {
    fetchPhysicalStockTakingListEdit()
  },[])

  
  const fetchPhysicalStockTakingListEdit = async () => {
    try{
      setLoading(true)
      const response = await axiosInstance.get(`/jobcard/warranty-claim-details/${data.claimWarrantyId}`,{
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    })
    const fetchedData = response.data.data.data[0];
   
    console.log(fetchedData, "FETCHEDDATA")
    const transformedData = {
    vendor_id:fetchedData.vendor_id,
    trn_no:fetchedData.trn_no,
    trn_date:fetchedData.trn_date,
    ref_no:fetchedData.ref_no,
    ref_date:fetchedData.ref_date,
    trn_total:fetchedData.trn_total,
    business_partner_id:fetchedData.business_partner_id,
    }
    setFormData(transformedData)
    setVendorId(fetchedData?.vendor_id)
    setPhysicalStockTakingList(fetchedData)

    
    const stockTypes = response.data.data[0].stock_types
    console.log(stockTypes, "STOCKTYPES")
    
    setStockTypesData(stockTypes)
    const businesspartnerid = response.data.data[0]?.business_partner_id;
    setBusinessPartnerIdState(businesspartnerid)
    console.log(businesspartnerid, "PARTNERID")
    
    console.log(formData, "depatartment DATA")
  
  }catch(error){
      console.log(error)
    }
    finally{
      setLoading(false)
    }
  }

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div>
      <div className="" >
        <div style={{paddingBottom:"35px", borderBottom:"1px solid lightgray", padding:"35px"}}>
      <span style={{fontWeight:"300", fontSize:"12px", paddingBottom:"5px", color:"gray", paddingLeft:"15px"}}>Services / Warranty Claims / Warranty Claims Details</span>
      <div className="backbutton" onClick={()=>navigate("/manage-services/warranty-claims")} >
        <img src={backicon} alt="back" />
          <span className="backbtntitleDetails"> Warranty Claims Details</span>
          
      </div>
        </div>
        
        <div >
        <div className="" >
        <h5 style={{paddingLeft:"55px"}} className='mt-2 mb-2 service-header header-details'>Claim Details</h5>
          <div className="detail-grid" style={{ paddingBottom:"30px", borderBottom:"1px solid lightgray", paddingLeft:"57px", paddingTop:"15px"}}>
            <div className="details-item">
              <span className="details-label">Claim Id</span>
              <span className="details-value"> {physicalStockTakingList.claimCode} </span>
             
            </div>
            <div className="details-item">
              <span className="details-label">Dealer Name</span>
              <span className="details-value">{physicalStockTakingList.dealer_name} </span>
              
            </div>
            <div className="details-item">
              <span className="details-label">Claim Name</span>
              <span className="details-value">{physicalStockTakingList.claimName} </span>
              
            </div>
            <div className="details-item">
              <span className="details-label">Cost</span>
              <span className="details-value">{physicalStockTakingList.cost} </span>
             
            </div>
            <div className="details-item">
              <span className="details-label">Warranty From</span>
              <span className="details-value">{physicalStockTakingList.warrantyFrom} </span>
            </div>
            <div className="details-item">
              <span className="details-label">Warranty To</span>
              <span className="details-value">{physicalStockTakingList.warrantyTo || "--"} </span>
              
            </div>
            {/* <div className="details-item">
              <span className="details-label">Warranty Type</span>
              <span className="details-value">{physicalStockTakingList.trn_total} </span>
              
            </div> */}
            <div className="details-item">
              <span className="details-label">Created Date</span>
              {new Date(physicalStockTakingList.createdAt).toLocaleDateString('en-GB')}
              
            </div>
            <div className="details-item">
              <span className="details-label">Claim Status</span>
              <span className="details-value">{physicalStockTakingList.repairStatus} </span>
              
            </div>

            <div className="details-item">
              <span className="details-label">Remarks</span>
              <span className="details-value">{physicalStockTakingList.remark} </span>
              
            </div>
          </div>

          {/* <div style={{paddingTop:"14px"}}> */}
          {/* <PhysicalStockin businessPartnerIdState={businessPartnerIdState} stockTypesData={stockTypesData} PhysicalStockinId={PhysicalStockinId } vendorId={vendorId} /> */}
          {/* </div> */}
        </div>
        <div className="" >
        <h5 style={{paddingLeft:"55px"}} className='mt-2 mb-2 service-header header-details'>Vehicle Details</h5>
          <div className="detail-grid" style={{ paddingBottom:"30px", borderBottom:"1px solid lightgray", paddingLeft:"57px", paddingTop:"15px"}}>
            <div className="details-item">
              <span className="details-label">Item Name</span>
              <span className="details-value"> {physicalStockTakingList.item_name || "--"} </span>
             
            </div>
            <div className="details-item">
              <span className="details-label">Product Name</span>
              <span className="details-value">{physicalStockTakingList.product_name || "- -"} </span>
              
            </div>
            <div className="details-item">
              <span className="details-label">Sub Product Name</span>
              <span className="details-value">{physicalStockTakingList.subproduct_name || "- -" } </span>
              
            </div>
            <div className="details-item">
              <span className="details-label">Make</span>
              <span className="details-value">{physicalStockTakingList.make_name || "- -" } </span>
             
            </div>
            <div className="details-item">
              <span className="details-label">Model</span>
              <span className="details-value">{physicalStockTakingList.model_name || "- -" } </span>
            </div>
            <div className="details-item">
              <span className="details-label">Variant</span>
              <span className="details-value">{physicalStockTakingList.variant_name || "- -" } </span>
              
            </div>
            {/* <div className="details-item">
              <span className="details-label">Color</span>
              <span className="details-value">{physicalStockTakingList.trn_total} </span>
              
            </div> */}
          </div>

          {/* <div style={{paddingTop:"14px"}}> */}
          {/* <PhysicalStockin businessPartnerIdState={businessPartnerIdState} stockTypesData={stockTypesData} PhysicalStockinId={PhysicalStockinId } vendorId={vendorId} /> */}
          {/* </div> */}
        </div>
        </div>
      </div>
      </div>
      )}
    </div>
  )
}

export default WarrantyClaimsDetails